/* eslint-disable camelcase */
<template>
  <div class="chat-bar__container">
    <div class="button__contents" v-if="$route.path !== '/chat'">
      <a :href="`tel:${tel}`"><img src="@/assets/btn_call.png" class="button-image" alt=""/></a>
    </div>
    <div class="button__contents" v-else  @click="$refs.file.click()">
      <img src="@/assets/icon/btn_upload.svg" class="button-image" alt=""/>
      <input type="file" id="uploadImage" ref="file" @change="addContract($event)" class="upload" style="display:none;" hidden multiple accept="image/*" />
    </div>
    <div class="chat-bar__contents" @click="handleTextValue">
      <textarea type="text" class="chat-bar-input" placeholder="매장과 채팅하기" v-model="textarea"
      @keyup.enter.prevent="handleChatContentsEnter" @keyup.delete="handleChatContentsDelete" />
    </div>
    <div class="button__contents" @click="handleSendMsg">
      <img src="@/assets/btn_send.png" class="button-image" alt="" />
    </div>
  </div>
</template>
<script>
import * as mutations from '@/graphql/mutations'
import { API } from 'aws-amplify'
export default {
  name: 'AppChatBar',
  props: {
    myUserSeq: String,
    myUserName: String
    // tel: String,
    // storeName: String,
    // storeSeq: String
  },
  data () {
    return {
      textarea: '',
      timeOut: ''
    }
  },
  computed: {
    tel () {
      return this.$store.state.storeInfo.STORE_TEL
    },
    storeName () {
      return this.$store.state.storeInfo.STORE_NAME
    },
    storeSeq () {
      return this.$route.query.seq
    }
  },
  async mounted () {
    // const vm = this
  },
  methods: {
    handleChatContentsDelete () {
      const vm = this
      clearTimeout(vm.timeOut)
      vm.timeOut = setTimeout(() => {
        vm.handleChatContentsEnter()
      }, 500)
    },
    handleChatContentsEnter () {
      const textRowArray = this.textarea.split('\n')
      const chatBarContainerElement = document.querySelector('.chat-bar__container')
      const chatBarContentsElement = document.querySelector('.chat-bar__contents')
      if (!this.$empty(textRowArray) && textRowArray.length < 5) {
        chatBarContainerElement.style.height = 60 + textRowArray.length * 10 + 'px'
        chatBarContentsElement.style.height = 40 + textRowArray.length * 10 + 'px'
      }
    },
    handleTextValue () {
      const vm = this
      if (this.$route.path !== '/chat') {
        vm.removeKakao()
        vm.moveRouter('chat')
      }
    },
    handleSendMsg () {
      const vm = this
      if (this.$route.path !== '/chat') {
        vm.removeKakao()
        vm.moveRouter('chat')
        return
      }
      vm.megSend()
    },
    handleChatingPage () {
      console.log('chat')
      const vm = this
      vm.moveRouter('chat')
    },
    async megSend () {
      const vm = this
      const message = vm.$_.cloneDeep(vm.textarea)
      if (vm.textarea.replace(/\s|/gi, '').length === 0) {
        return
      }
      vm.textarea = ''
      if (vm.$empty(vm.myUserSeq) && vm.$empty(vm.myUserName)) {
        await vm.setMyUserSeq()
        vm.myUserSeq = localStorage.getItem(`${vm.$route.query.seq}_userSeq`)
        const flowerName = await vm.$axios.get(`${process.env.API}/getFlowerName/${localStorage.getItem(`${vm.$route.query.seq}_userIndex`)}`)
        // console.log('getFlowerName :::::', flowerName.data)
        vm.myUserName = `${flowerName.data.flowerName}`
        vm.$store.state.customerName = vm.myUserName
        vm.$cookies.set('userName', vm.myUserName)
      }
      if (vm.$empty(vm.myUserSeq)) {
        alert('사용자 정보 오류\n새로고침 후 다시 이용해주세요.')
        return
      }
      const datetime = vm.$dayjs().format('YYYYMMDDHHmmssSSS')
      const data = {
        storeSeq: vm.$route.query.seq,
        sK: `CHAT#LIVE#${datetime}`,
        datetime: vm.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
        contents: message,
        name: vm.myUserName,
        type: 'live_questioner',
        roomType: 'live',
        userSeq: vm.myUserSeq,
        userPhone: !vm.$empty(vm.$store.state.customerPhone) ? vm.$store.state.customerPhone : ''
      }
      const sendData = {
        data: data
      }
      vm.$emit('handleAddData', sendData)
      const data2 = {
        storeSeq: vm.$route.query.seq,
        sK: 'ROOM#LIVE',
        datetime: vm.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
        contents: message
      }
      delete data.holdingDisplayDate
      await API.graphql({
        query: mutations.createStoreQnaInfoTable,
        variables: { input: data }
      })
      await API.graphql({
        query: mutations.updateStoreQnaInfoTable,
        variables: { input: data2 }
      })

      await vm.sendPush()
      vm.sendMsgTelegram(datetime, message)

      // vm.textarea = ''
      vm.handleChatContentsEnter()
    },
    async sendPush () {
      const vm = this
      await vm.$axios.get(`https://www.sery.co.kr/store/v1/${vm.$route.query.seq}/push`)
    },
    sendMsgTelegram (datetime, message) {
      const vm = this
      if (!vm.$empty(vm.storeName) && !vm.$empty(vm.storeSeq)) {
        const data = {
          storeName: `${vm.storeName} (${vm.storeSeq})`,
          userName: vm.myUserName,
          type: 'tery-web',
          datetime: datetime,
          contents: message
        }
        vm.$axios.post(`${process.env.telegram}/tery-chat`, data)
        // vm.$axios.post(`http://192.168.0.2:3001/tery-chat`, data)
      } else {
        setTimeout(() => {
          const data = {
            storeName: `${vm.$store.state.storeInfo.STORE_NAME} (${vm.$route.query.seq})`,
            userName: vm.myUserName,
            type: 'tery-web',
            datetime: datetime,
            contents: message
          }
          vm.$axios.post(`${process.env.telegram}/tery-chat`, data)
        }, 1000)
      }
    },
    addContract (value) {
      this.readUploadImage(value.target.files[0])
    },
    readUploadImage (inputObject) {
      // this.url = inputObject
      if (window.File && window.FileReader) {
        let resizeWidth = 1000
        if (inputObject) {
          if (!/image/i.test(inputObject.type)) {
            alert('이미지 파일을 선택해 주세요!')
            return false
          } else {
            /// ///console.log('3-2')
          }
          const vm = this

          var reader = new FileReader()
          reader.readAsDataURL(inputObject)
          reader.name = inputObject.name
          reader.size = inputObject.size
          reader.onload = function (e) {
            var img = new Image()
            img.src = e.target.result
            img.name = e.target.name
            img.size = e.target.size
            img.onload = function (el) {
              var elem = document.createElement('canvas')
              if (el.target.width > resizeWidth) {
                var scaleFactor = resizeWidth / el.target.width
                elem.width = resizeWidth
                elem.height = el.target.height * scaleFactor
              } else {
                elem.width = el.target.width
                elem.height = el.target.height
              }

              var ctx = elem.getContext('2d')
              ctx.drawImage(el.target, 0, 0, elem.width, elem.height)

              // get the base64-encoded Data URI from the resize image
              // var srcEncoded = ctx.canvas.toDataURL(el.target, 'image/jpeg', 0)

              // vm.textarea = srcEncoded
              const extCheck = reader.name.split('.')
              // extCheck[extCheck.length - 1] = '.png'
              // reader.name = extCheck.join('')
              ctx.canvas.toBlob(blob => {
                // 업로드 URL
                vm.$axios({
                  method: 'get',
                  url: `${process.env.API}/getImageUploadUrl/${vm.storeSeq}/${reader.name}`
                  // url: `http://192.168.0.2:3005/getImageUploadUrl/${vm.storeSeq}/${reader.name}`
                }).then((response) => {
                  console.log('getImageUploadUrl :::::', response.data)
                  // 업로드
                  vm.$axios({
                    method: 'put',
                    url: `${response.data.url.signedUrl}`,
                    headers: {
                      'Content-Type': `image/${extCheck[extCheck.length - 1]}`
                    },
                    data: blob
                  }).then((response) => {
                    console.log('putImageUploadUrl :::::', response.data)
                  }).catch(error => {
                    console.log('putImageUploadUrl error :::::', error)
                  })
                  vm.textarea = encodeURI(response.data.url.getUrl)
                  vm.megSend()
                }).catch(error => {
                  console.log('getImageUploadUrl error :::::', error)
                })
              }, `image/${extCheck[extCheck.length - 1]}`)
              // vm.megSend()
            }
          }
        }
      } else {
        alert('미리보기 안됨')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/main.scss';
.chat-bar__container {
  position: fixed;
  bottom: $adContainerHeight;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #fff8f8;
  display: flex;
  align-items: center;
  z-index: 100;
}
.chat-bar__container > .button__contents {
  flex: none;
  width: 50px;
  text-align: center;
}
.button-image {
  width: 40px;
  height: 40px;
}

.chat-bar__container > .chat-bar__contents {
  flex: 1;
  height: 40px;
  .chat-bar-input {
    resize: none;
    color: hsl(0, 0%, 0%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chat/AppChatBar.vue